import { Injectable } from '@angular/core';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import { TextFilter, HistoricalComboAthlete, CountryCombo, YesNotCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FilterCoachesService extends FiltersAbstractService {
  textFilter = new TextFilter('text');
  activeCombo = new HistoricalComboAthlete('Status:', 'currentcombo', undefined,
  [{ item: { Name: 'All', Value: undefined }, position: 0 }, { item: { Name: 'Current', Value: true },
  position: 1 }, {item:{Name:'Historical:', Value:false}}]);
  countryCombo = new CountryCombo('Country:', 'country-combo', this.http,  [{ item: { CShort: 'All' }, position: 0 }], 'country', true, true );
  nationalityCombo = new CountryCombo('Nationality:', 'nationality-combo', this.http,  [{ item: { CShort: 'All' }, position: 0 }], 'nationality', true, true );

  /**
   * Filters of coaches service
   *
   * @memberof FilterCoachesService
   */
  filtersType = [
    this.textFilter.filterInfo,
    this.nationalityCombo.filterInfo,
    this.countryCombo.filterInfo,
    this.activeCombo.filterInfo,

  ]

  constructor(private http:HttpClient) {
    super()
   }

  /**
   *
   *
   * @memberof FilterCoachesService
   */
  generateDefaultValues(): void {

  }

  /**
   * Filter data of coaches service
   *
   * @returns
   * @memberof FilterCoachesService
   */
  getDataStreamWithFilters(){
    return combineLatest([
      this.orderSubject,
      this.textFilter.data(),
      this.activeCombo.comboData,
      this.countryCombo.comboData.pipe(filter(a=> a != undefined)),
      this.nationalityCombo.comboData.pipe(filter(a=> a != undefined))]
      )
  }
}
